module.exports = __webpack_public_path__ + "static/media/cloud.885b67e5.svg";